import $ from 'jquery'
import PerfectScrollbar from 'perfect-scrollbar/dist/perfect-scrollbar.esm'

// function configureChart() {
//   const ChartColor = ['#5D62B4', '#54C3BE', '#EF726F', '#F9C446', 'rgb(93.0, 98.0, 180.0)', '#21B7EC', '#04BCCC']
//   const primaryColor = getComputedStyle(document.body).getPropertyValue('--primary')
//   const secondaryColor = getComputedStyle(document.body).getPropertyValue('--secondary')
//   const successColor = getComputedStyle(document.body).getPropertyValue('--success')
//   const warningColor = getComputedStyle(document.body).getPropertyValue('--warning')
//   const dangerColor = getComputedStyle(document.body).getPropertyValue('--danger')
//   const infoColor = getComputedStyle(document.body).getPropertyValue('--info')
//   const darkColor = getComputedStyle(document.body).getPropertyValue('--dark')
//   const lightColor = getComputedStyle(document.body).getPropertyValue('--light')
//   let chartFontcolor = '#6c757d'
//   let chartGridLineColor = 'rgba(0,0,0,0.08)'
//   if ($('body').hasClass('dark-theme')) {
//     chartFontcolor = '#b9c0d3'
//     chartGridLineColor = '#383e5d'
//   }
//   if ($('canvas').length) {
//     Chart.defaults.global.tooltips.enabled = false
//     Chart.defaults.global.defaultFontColor = '#354d66'
//     Chart.defaults.global.defaultFontFamily = '"Poppins", sans-serif'
//     Chart.defaults.global.tooltips.custom = function (tooltipModel) {
//       // Tooltip Element
//       const tooltipEl = document.getElementById('chartjs-tooltip')
//
//       // Create element on first render
//       if (!tooltipEl) {
//         tooltipEl = document.createElement('div')
//         tooltipEl.id = 'chartjs-tooltip'
//         tooltipEl.innerHTML = '<table></table>'
//         document.body.appendChild(tooltipEl)
//       }
//
//       // Hide if no tooltip
//       if (tooltipModel.opacity === 0) {
//         tooltipEl.style.opacity = 0
//         return
//       }
//
//       // Set caret Position
//       tooltipEl.classList.remove('above', 'below', 'no-transform')
//       if (tooltipModel.yAlign) {
//         tooltipEl.classList.add(tooltipModel.yAlign)
//       }
//       else {
//         tooltipEl.classList.add('no-transform')
//       }
//
//       function getBody(bodyItem) {
//         return bodyItem.lines
//       }
//
//       // Set Text
//       if (tooltipModel.body) {
//         const titleLines = tooltipModel.title || []
//         const bodyLines = tooltipModel.body.map(getBody)
//
//         const innerHtml = '<thead>'
//
//         titleLines.forEach(function (title) {
//           innerHtml += '<tr><th>' + title + '</th></tr>'
//         })
//         innerHtml += '</thead><tbody>'
//
//         bodyLines.forEach(function (body, i) {
//           const colors = tooltipModel.labelColors[i]
//           const style = 'background:' + colors.borderColor
//           style += ' border-color:' + colors.borderColor
//           style += ' border-width: 2px'
//           const span = '<span style="' + style + '"></span>'
//           innerHtml += '<tr><td>' + span + body + '</td></tr>'
//         })
//         innerHtml += '</tbody>'
//
//         const tableRoot = tooltipEl.querySelector('table')
//         tableRoot.innerHTML = innerHtml
//       }
//
//       // `this` will be the overall tooltip
//       const position = this._chart.canvas.getBoundingClientRect()
//
//       // Display, position, and set styles for font
//       tooltipEl.style.opacity = 1
//       tooltipEl.style.position = 'absolute'
//       tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px'
//       tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px'
//       tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily
//       tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px'
//       tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle
//       tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px'
//       tooltipEl.style.pointerEvents = 'none'
//     }
//     Chart.defaults.global.legend.labels.fontStyle = 'italic'
//     Chart.defaults.global.tooltips.intersect = false
//   }
// }

/**
 * Apply PerfectScrollbar
 */
function initializePerfectScrollbar() {
  const body = $('body')
  if ( ! body.hasClass('rtl')) {
    if ($('.settings-panel .tab-content .tab-pane.scroll-wrapper').length) {
      const settingsPanelScroll = new PerfectScrollbar('.settings-panel .tab-content .tab-pane.scroll-wrapper')
    }
    if ($('.chats').length) {
      const chatsScroll = new PerfectScrollbar('.chats')
    }
    if ($('.scroll-container').length) {
      const ScrollContainer = new PerfectScrollbar('.scroll-container')
    }
    if (body.hasClass('sidebar-fixed')) {
      let fixedSidebarScroll = new PerfectScrollbar('#sidebar .nav')
    }
    if ($('.ps-enabled').length) {
      const psEnabled = new PerfectScrollbar('.ps-enabled')
    }
  }
}

/**
 * Switch themes
 */
function themeSwitch(url) {
  const currentURL = window.location.href
  const res = currentURL.split('/')
  const abs_url = currentURL.replace(/demo_.\d*/, url)
  window.location.href = abs_url
}

/**
 * Register misc event handlers.
 */
function listenToMiscEvents() {
  const body = $('body')
  const contentWrapper = $('.content-wrapper')
  const scroller = $('.container-scroller')
  const footer = $('.footer')
  const sidebar = $('#sidebar')

  //Add active class to nav-link based on url dynamically
  //Active class can be hard coded directly in html file also as required
  if ( ! $('#sidebar').hasClass('dynamic-active-class-disabled')) {
    let current = location.pathname.split('/').slice(-1)[0].replace(/^\/|\/$/g, '')
    $('#sidebar >.nav > li:not(.not-navigation-link) a').each(function() {
      let $this = $(this)
      if (current === '') {
        //for root url
        if ($this.attr('href').indexOf('index.html') !== -1) {
          $(this).parents('.nav-item').last().addClass('active')
          if ($(this).parents('.sub-menu').length) {
            $(this).addClass('active')
          }
        }
      }
      else {
        //for other url
        if ($this.attr('href').indexOf(current) !== -1) {
          $(this).parents('.nav-item').last().addClass('active')
          if ($(this).parents('.sub-menu').length) {
            $(this).addClass('active')
          }
          if (current !== 'index.html') {
            $(this).parents('.nav-item').last().find('.nav-link').attr('aria-expanded', 'true')
            if ($(this).parents('.sub-menu').length) {
              $(this).closest('.collapse').addClass('show')
            }
          }
        }
      }
    })
  }

  // $('.email-wrapper .mail-list-container .mail-list').on('click', function () {
  //   $('.email-wrapper .mail-list-container').addClass('d-none')
  //   $('.email-wrapper .mail-view').addClass('d-block')
  // })
  // $('.email-wrapper .mail-back-button').on('click', function () {
  //   $('.email-wrapper .mail-list-container').removeClass('d-none')
  //   $('.email-wrapper .mail-view').removeClass('d-block')
  // })
  // $('.aside-toggler').on('click', function () {
  //   $('.mail-sidebar,.chat-list-wrapper').toggleClass('menu-open')
  // })
  // $('#color-setting').on('click', function () {
  //   $('#color-settings').addClass('open')
  // })
  // $('#layout-toggler').on('click', function () {
  //   $('#theme-settings').addClass('open')
  // })
  // $('#chat-toggler').on('click', function () {
  //   $('#right-sidebar').addClass('open')
  // })

  //Close other submenu in sidebar on opening any
  $('#sidebar > .nav > .nav-item > a[data-toggle="collapse"]').on('click', function () {
    $('#sidebar > .nav > .nav-item').find('.collapse.show').collapse('hide')
  })

  $('[data-toggle="minimize"]').on('click', function() {
    body.toggleClass('sidebar-icon-only')
  })

  //checkbox and radios
  $('.form-check label,.form-radio label').append('<i class="input-helper"></i>')
}

/**
 * Register the click nav item event listener.
 */
function listenToClickNavItem() {
  $('[data-toggle="tooltip"]').tooltip()
  $('.sidebar .sidebar-inner > .nav > .nav-item').not('.brand-logo').attr('toggle-status', 'closed')
  $('.sidebar .sidebar-inner > .nav > .nav-item').on('click', onClickNavItem)
}

/**
 * Handle the click nav item event.
 */
function onClickNavItem() {
  $('.sidebar .sidebar-inner > .nav > .nav-item').removeClass('active')
  $(this).addClass('active')
  $('.sidebar .sidebar-inner > .nav > .nav-item').find('.submenu').removeClass('open')
  $('.sidebar .sidebar-inner > .nav > .nav-item').not(this).attr('toggle-status', 'closed')
  const toggleStatus = $(this).attr('toggle-status')
  if (toggleStatus == 'closed') {
    $(this).find('.submenu').addClass('open')
    $(this).attr('toggle-status', 'open')
  }
  else {
    $(this).find('.submenu').removeClass('open')
    $(this).not('.brand-logo').attr('toggle-status', 'closed')
  }
}

/**
 * Register events for switching between light and dark themes.
 */
function listenToSwitchTheme() {
  $('#theme-light-switch').on('click', onSwitchLightTheme)
  $('#theme-dark-switch').on('click', onSwitchDarkTheme)
}

/**
 * Handle the switch to light theme event.
 */
function onSwitchLightTheme() {
  e.preventDefault()
  themeSwitch('demo_1')
}

/**
 * Handle the switch to dark theme event.
 */
function onSwitchDarkTheme() {
  e.preventDefault()
  themeSwitch('demo_3')
}

export {
  // configureChart,
  listenToClickNavItem,
  listenToSwitchTheme,
  listenToMiscEvents,
  initializePerfectScrollbar,
}
